import { render, staticRenderFns } from "./CreateFixedAssetCategory.vue?vue&type=template&id=09bd043c"
import script from "./CreateFixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./CreateFixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports